// mounting bracket products must have one of these association types
export enum MountingBracketAssociationType {
  MountingBracketsFixed = 'mounting_brackets_fixed',
  MountingBracketsKMAPivotingOneSided = 'mounting_brackets_KMA_pivoting_one_sided',
  MountingBracketsKMAAbbreviatedPivoting = 'mounting_brackets_KMA_abbreviated_pivoting',
  MountingBracketsKMAAbbreviatedFixed = 'mounting_brackets_KMA_abbreviated_fixed',
  MountingBracketsKMALongPivoting = 'mounting_brackets_KMA_long_pivoting',
  MountingBracketsKMALongFixed = 'mounting_brackets_KMA_long_fixed',
  MountingBracketsKMAPivoting = 'mounting_brackets_KMA_pivoting',
  MountingBracketsKMAFixed = 'mounting_brackets_KMA_fixed',
  MountingBracketsPolymerSmallInstallationSpacesPivoting = 'mounting_brackets_polymer_small_installation_spaces_pivoting',
  MountingBracketsPolymerFixed = 'mounting_brackets_polymer_fixed',
  MountingBracketsPolymerPivoting = 'mounting_brackets_polymer_pivoting',
  MountingBracketsPolymerPivotingOneSided = 'mounting_brackets_polymer_pivoting_one_sided',
  MountingBracketsSteelPivoting = 'mounting_brackets_steel_pivoting',
  MountingBracketsSteelFixed = 'mounting_brackets_steel_fixed',
  MountingBracketsSteelFlangePivoting = 'mounting_brackets_steel_flange_pivoting',
  MountingBracketsSteelFlangeFixed = 'mounting_brackets_steel_flange_fixed',
  MountingBracketsSteelPivotingOneSided = 'mounting_brackets_steel_pivoting_one_sided',
}

export const allowedUnmountedMountingBracketAssociationTypes = [
  MountingBracketAssociationType.MountingBracketsSteelPivoting,
  MountingBracketAssociationType.MountingBracketsSteelFixed,
  MountingBracketAssociationType.MountingBracketsSteelFlangePivoting,
  MountingBracketAssociationType.MountingBracketsSteelFlangeFixed,
  MountingBracketAssociationType.MountingBracketsSteelPivotingOneSided,
];

// different types of associations for a product
export enum AssociationType {
  NEW_PRODUCT = 'new_product',
  ALTERNATIVE_PRODUCT = 'alternative_product',
  SUITABLE_PRODUCT = 'suitable_product',
  CF_CASE = 'cf_case',
  MOUNTING_BRACKETS = 'mounting_brackets',
  MOUNTING_BRACKETS_TRIFLEX = 'mounting_brackets_triflex',
  SEPARATORS = 'separators',
  CABLES = 'cables',
  SHELVES = 'shelves',
  SUPPORT_TRAY = 'support_trays',
  ACCESSORIES = 'accessories',
}
